import { Button } from '@shinetools/lumen-react'
import { Columns3Cog } from 'lucide-react'
import { ComponentPropsWithoutRef, forwardRef } from 'react'
import { useTranslation } from 'react-i18next'

export const SuppliersTableColumnSelectionMenuTrigger = forwardRef<
  HTMLButtonElement,
  Omit<ComponentPropsWithoutRef<'button'>, 'color'>
>((props, ref) => {
  const { t } = useTranslation()

  return (
    <Button
      ref={ref}
      aria-label={t('table_column_toggler.toggle_columns')}
      variant="outlined"
      icon={<Columns3Cog />}
      {...props}
    />
  )
})

SuppliersTableColumnSelectionMenuTrigger.displayName = 'SuppliersTableColumnSelectionMenuTrigger'
